import spacemonkEntitySchema from './spacemonk-entity-schema.json';

// Convert JSON Schema (of Schemas) to Spacemonk Schema
export const schemaOfSchema = {
  id: 'schema',
  name: 'schema',
  title: 'Schemas (Spacemonk)',
  icon: 'Settings',
  properties: Object.keys(spacemonkEntitySchema.properties).map(propName => ({ name: propName })),
  $jsonSchema: {
    ...spacemonkEntitySchema
  },
  permissions: {
    read: ['spacemonk'],
    create: ['spacemonk'],
    update: ['spacemonk'],
    delete: ['spacemonk'],
  }
};
